<template>
  <div>
    <!-- 智能客服窗口 -->
    <div
      class="chat-wrapper"
      v-show="showChat"
      :style="{ left: posX + 'px', top: posY + 'px' }"
    >
      <div class="chat-container">
        <div class="chat-header" ref="dragHeader">
          <el-button
            icon="el-icon-arrow-left"
            circle
            size="mini"
            @click="handleBack"
            class="back-button"
          ></el-button>
          <h3>智能客服</h3>
        </div>

        <div class="chat-messages" ref="messagesContainer">
          <div
            v-for="(message, index) in messages"
            :key="index"
            :class="['message', message.type]"
          >
            <div
              class="message-content"
              v-html="renderMarkdown(message.content)"
            ></div>
            <div class="message-time">
              {{ formatTime(message.time) }}
            </div>
          </div>
        </div>

        <div class="chat-input">
          <el-input
            v-model="inputMessage"
            placeholder="请输入您的问题..."
            @keyup.enter.native="sendMessage"
            :disabled="isLoading"
          >
            <el-button
              slot="append"
              icon="el-icon-s-promotion"
              @click="sendMessage"
              :loading="isLoading"
            ></el-button>
          </el-input>
        </div>
      </div>
    </div>

    <!-- 悬浮助手 -->
    <div
      class="floating-assistant"
      :class="{ active: showMenu }"
      @click.stop="toggleMenu"
    >
      <div class="assistant-bubble" v-if="showMenu">
        <div class="menu-item" @click="toggleChat">
          <span class="icon"><i class="el-icon-help"></i></span> 使用帮助
        </div>
        <div class="menu-item" @click="showContactDialog">
          <span class="icon"><i class="el-icon-headset"></i></span> 联系我们
        </div>
      </div>
      <img src="../assets/aiAssistant.png" class="assistant-icon" />
    </div>

    <!-- 联系我们弹窗 -->
    <el-dialog
      title="联系我们"
      :visible.sync="contactVisible"
      width="30%"
      center
    >
      <div class="contact-content">
        <p><i class="el-icon-phone"></i> 客服电话：400-123-4567</p>
        <p><i class="el-icon-message"></i> 服务邮箱：service@company.com</p>
        <p><i class="el-icon-time"></i> 工作时间：工作日 9:00-18:00</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";

export default {
  data() {
    return {
      // 聊天消息相关
      inputMessage: "",
      isLoading: false,
      messages: [
        {
          type: "received",
          content: "您好，我是智能客服小L，请问有什么可以帮您？",
          time: new Date(),
        },
      ],

      // API配置
      apiConfig: {
        url: "https://dashscope.aliyuncs.com/compatible-mode/v1/chat/completions",
        apiKey: "sk-2705634a860d484dbbe621e6e618bef0",
        model: "qwen-plus",
      },

      // 窗口控制相关
      showMenu: false,
      showChat: false,
      contactVisible: false,
      posX: 0,
      posY: 0,
      isDragging: false,
      startX: 0,
      startY: 0,

      // Markdown处理器
      md: null,
    };
  },
  created() {
    this.initMarkdown();
  },
  methods: {
    // 初始化Markdown解析器
    initMarkdown() {
      this.md = new MarkdownIt({
        html: true,
        linkify: true,
        highlight: (str, lang) => {
          if (lang && hljs.getLanguage(lang)) {
            try {
              return hljs.highlight(str, { language: lang }).value;
            } catch (_) {}
          }
          return "";
        },
      });
    },

    // Markdown渲染
    renderMarkdown(content) {
      return this.md.render(content);
    },

    // 发送消息
    async sendMessage() {
      if (!this.inputMessage.trim() || this.isLoading) return;

      try {
        this.isLoading = true;
        const userMessage = this.inputMessage;

        // 添加用户消息
        this.messages.push({
          type: "sent",
          content: userMessage,
          time: new Date(),
        });

        // API
        const response = await axios.post(
          this.apiConfig.url,
          {
            model: this.apiConfig.model,
            messages: [
              ...this.messages.slice(-3).map((m) => ({
                role: m.type === "sent" ? "user" : "assistant",
                content: m.content,
              })),
              { role: "user", content: userMessage },
            ],
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.apiConfig.apiKey}`,
            },
          }
        );

        // 添加助手回复
        const answer = response.data.choices[0].message.content;
        this.messages.push({
          type: "received",
          content: answer,
          time: new Date(),
        });

        this.inputMessage = "";
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      } catch (error) {
        console.error("请求失败:", error);
        this.messages.push({
          type: "received",
          content: "服务暂时不可用，请稍后再试",
          time: new Date(),
        });
      } finally {
        this.isLoading = false;
      }
    },
    scrollToBottom() {
      const container = this.$refs.messagesContainer;
      container.scrollTop = container.scrollHeight;
    },
    formatTime(time) {
      return time.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    handleBack() {
      this.showChat = false;
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    toggleChat() {
      this.showChat = !this.showChat;
      this.showMenu = false;
      if (this.showChat && window.innerWidth > 768) {
        this.posX = window.innerWidth - 640;
        this.posY = window.innerHeight / 2 - 350;
      }
    },
    showContactDialog() {
      this.contactVisible = true;
      this.showMenu = false;
    }, 
    // 拖动
    enableDrag() {
      const header = this.$refs.dragHeader;
      header.addEventListener("mousedown", this.startDrag);
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
    },
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.clientX - this.posX;
      this.startY = e.clientY - this.posY;
      document.body.style.userSelect = "none";
    },
    onDrag(e) {
      if (!this.isDragging) return;
      let newX = e.clientX - this.startX;
      let newY = e.clientY - this.startY;

      const maxX = window.innerWidth - 600;
      const maxY = window.innerHeight - 200;
      newX = Math.max(20, Math.min(newX, maxX));
      newY = Math.max(20, Math.min(newY, maxY));

      this.posX = newX;
      this.posY = newY;
    },
    stopDrag() {
      this.isDragging = false;
      document.body.style.userSelect = "";
    },
  },
  mounted() {
    if (window.innerWidth > 768) {
      this.enableDrag();
    }
    document.addEventListener("click", () => {
      this.showMenu = false;
    });
    this.scrollToBottom();
  },
  beforeDestroy() {
    document.removeEventListener("mousemove", this.onDrag);
    document.removeEventListener("mouseup", this.stopDrag);
  },
};
</script>

<style scoped>
.message-content >>> pre {
  background: #f8f8f8;
  padding: 1em;
  border-radius: 5px;
  overflow-x: auto;
}

.message-content >>> code {
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
}

.message-content >>> .hljs {
  display: block;
  overflow-x: auto;
  padding: 0.5em;
  background: #f8f8f8;
}

.message-content >>> .hljs-keyword {
  color: #d73a49;
}

.message-content >>> .hljs-string {
  color: #032f62;
}
/* 聊天窗口样式 */
.chat-wrapper {
  position: fixed;
  right: 40px;
  bottom: 160px;
  z-index: 10000;
  transition: all 0.3s ease;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  cursor: move;
}

.chat-container {
  display: flex;
  flex-direction: column;
  height: 700px;
  width: 600px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background-color: #f5f7fa;
}

.chat-header {
  padding: 20px;
  background-color: #409eff;
  color: white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  text-align: center;
  position: relative;
  cursor: move;
  transition: background 0.2s;
}

.chat-header:hover {
  background: #66b1ff !important;
}

.chat-messages {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.message {
  margin-bottom: 20px;
  max-width: 85%;
  word-wrap: break-word;
  font-size: 15px;
}

.message.sent {
  align-self: flex-end;
  background-color: #409eff;
  color: white;
  border-radius: 12px 12px 0 12px;
  padding: 10px 15px;
}

.message.received {
  align-self: flex-start;
  background-color: white;
  border-radius: 12px 12px 12px 0;
  padding: 10px 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.message-time {
  font-size: 13px;
  color: #999;
  margin-top: 6px;
}

.chat-input {
  padding: 15px;
  background-color: white;
  border-top: 1px solid #ebeef5;
}

/* 悬浮助手样式 */
.floating-assistant {
  position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: 10001;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.assistant-icon {
  width: 80px;
  height: 80px;
  filter: drop-shadow(0 5px 10px rgba(0, 0, 0, 0.2));
  transition: transform 0.3s;
}

.floating-assistant:hover .assistant-icon {
  transform: rotate(-15deg) scale(1.1);
}

.assistant-bubble {
  position: absolute;
  bottom: calc(100% + 15px);
  right: 0;
  background: white;
  border-radius: 20px;
  padding: 15px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  width: 160px;
  animation: bubbleAppear 0.3s ease;
}

.menu-item {
  padding: 10px;
  margin: 5px 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  transition: background 0.2s;
}

.menu-item:hover {
  background: #f8f9fa;
}

.icon {
  margin-right: 8px;
  font-size: 20px;
}

/* 联系弹窗样式 */
.contact-content {
  text-align: center;
  font-size: 16px;
  line-height: 2;
  padding: 20px;
}

.contact-content i {
  margin-right: 10px;
  color: #409eff;
}

/* 动画 */
@keyframes bubbleAppear {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式 */
@media (max-width: 768px) {
  .chat-wrapper {
    right: 10px;
    bottom: 120px;
    width: 95%;
    height: 70vh;
    left: 0 !important;
    top: 0 !important;
  }

  .chat-container {
    height: 100vh;
    width: 100%;
    border-radius: 0;
  }

  .floating-assistant {
    right: 15px;
    bottom: 20px;
  }

  .assistant-icon {
    width: 60px;
    height: 60px;
  }
}
</style>